import { useEffect } from 'react';
import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps';
export const CIVIL_COLORS = { segment: '#0369a1', manhole: '#7c3aed', fat: '#047857', odc: '#a16207', closure: '#be185d' };
function Layers({ units, parts }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !window.google?.maps) return undefined;
    const bounds = new window.google.maps.LatLngBounds();
    const paths = [];
    const draw = (item, part = false) => {
      const g = item.geometry;
      if (!g || item.status === 'dropped') return;
      const color = item.mapping_status === 'unmapped' ? '#dc2626' : CIVIL_COLORS[item.kind] || '#0f172a';
      if (g.type === 'LineString') {
        const path = g.coordinates.map(([lng, lat]) => ({ lat, lng }));
        path.forEach((p) => bounds.extend(p));
        paths.push(new window.google.maps.Polyline({ map, path, strokeColor: part ? '#f8fafc' : color, strokeWeight: part ? 2 : 7, strokeOpacity: 1, clickable: false }));
        if (part && path.length) paths.push(new window.google.maps.Circle({ map, center: path[0], radius: 1.5, fillColor: '#0f172a', fillOpacity: 1, strokeColor: '#0f172a', clickable: false }));
      } else if (g.type === 'Point' && !part) {
        const center = { lng: g.coordinates[0], lat: g.coordinates[1] }; bounds.extend(center);
        paths.push(new window.google.maps.Circle({ map, center, radius: 5, fillColor: color, fillOpacity: 1, strokeColor: '#ffffff', strokeWeight: 2, clickable: false }));
      }
    };
    units.forEach((u) => draw(u)); parts.forEach((p) => draw(p, true));
    if (!bounds.isEmpty()) map.fitBounds(bounds, 32);
    return () => paths.forEach((p) => p.setMap(null));
  }, [map, units, parts]);
  return null;
}
export default function CivilAreasMap({ units, parts }) {
  if (!process.env.REACT_APP_GOOGLE_MAPS_API_KEY) return <p role="status">کلید نقشه تنظیم نشده است؛ فهرست واحدها در پایین در دسترس است.</p>;
  return <div className="civil-map" aria-label="نقشهٔ واحدها و قطعات اجرا"><APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} language="fa" region="IR">
    <Map defaultCenter={{ lat: 35.72, lng: 51.33 }} defaultZoom={12} gestureHandling="greedy"><Layers units={units} parts={parts} /></Map>
  </APIProvider></div>;
}
